import { Component,ViewEncapsulation, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
//import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { distinctUntilChanged } from 'rxjs/operators';

import {AppSettings} from './settings';
import {MessageService} from './message.service';
import { Subscription } from 'rxjs';
import * as moment from 'moment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation:ViewEncapsulation.None,
 
})
export class AppComponent  implements OnInit {

  msgSubscription:Subscription;

  currentTimeStamp() {
     try {
      var timestamp = new Date();
      var time = moment(timestamp).utc().format("YYYYMMDDHHmmss");
      return time;
     } catch(e) {
      return "unknown";
     }
    }

  constructor(private msg:MessageService,private router: Router,private $gaService: GoogleAnalyticsService){

    this.router.events.subscribe(event => {
     
        if (event instanceof NavigationEnd) {
          if(AppSettings.GA_ID){
            this.$gaService.pageView(event.urlAfterRedirects, 'page')
          }
        }
    });

    this.msgSubscription = this.msg.getMessage().subscribe( (e) =>{

      if(e!=undefined){

        switch(e.text.type){

          case 'customeEvent':

              let time = this.currentTimeStamp()

              let gtmTag = {
                event: e.text.event,
                value: e.text.value,
                source: e.text.source,
                userId:localStorage.user,
                timestamp: time

              };

              if(e.text.newsletterId!=undefined){
                gtmTag['newsletterId'] = e.text.newsletterId
              }
              if(e.text.articleId!=undefined){
                gtmTag['articleId'] = e.text.articleId
              }
              if(AppSettings.GTM_ID){
                //this.gtmService.pushTag(gtmTag);
              }

              break;
        }

      }

    })

    


  }



ngOnInit() {

      this.router.events.pipe(distinctUntilChanged((previous: any, current: any) => {
        if(current instanceof NavigationEnd) {
          if(previous.url != current.url){
            let prev = previous.url.split('?')
            let curr = current.url.split('?')
            let newprev = prev[0].split('/')
            let newcurr = curr[0].split('/')


            if(newprev[1]=='vlogin' || newprev[1]=='autologin' || newprev[1]=='login'){
              localStorage.setItem('previous','login')
            }else{
              localStorage.setItem('previous',newprev[1])
            }
           
            localStorage.setItem('current',newcurr[1])
          }
          return previous.url === current.url;
        }
        return true;
  
       })).subscribe((x: any) => {  

              let url = x.url.split('?')
              let newurl = url[0].split('/')
             
             if(localStorage.previous!=localStorage.current && newurl[1]!='search' && newurl[3]!='view'){
                
              let time = this.currentTimeStamp()
              const gtmTag = {
                  event: 'page', 
                  source:localStorage.previous,
                  value:localStorage.current,                 
                  userId:localStorage.user,
                  timestamp: time                  
                };
                if(AppSettings.GTM_ID){
                  //this.gtmService.pushTag(gtmTag);
                }

             }
             
        });
  
    }


    ngOnDestroy(){

      this.msgSubscription.unsubscribe();

    }



}
